import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { Radio } from ".";

const store = proxy<Partial<Radio>>({});

export const toolkitRadioActions = {
  mergeRadio(payload: Partial<Radio>) {
    Object.assign(store, payload);
  },
};

export function useToolkitRadioStore() {
  return useSnapshot(store);
}

export function getToolkitRadioState() {
  return snapshot(store);
}

export function resetToolkitRadioStore() {
  for (const key of Object.keys(store)) {
    delete store[key as keyof Radio];
  }
}
